import { isLocalhostOrPreview, isStaging } from 'src/utils/url'

const siteKeyStaging = '6Lc9CDgqAAAAANEvrogCryrJl8sX9XI1lSyB-r3P'
const siteKeyProd = '6LfBCDgqAAAAAMAcVUqn4LOWpm9nNdjbhKvXl00B'

export const getRecaptchaSiteKey = () => {
  return isLocalhostOrPreview || isStaging() ? siteKeyStaging : siteKeyProd
}
